import { io } from 'socket.io-client'
import { SOCKET_CONNECTION_URL } from './endpoints'

let socket = null
let registeredUserId = ''

export const getChatRealtimeSocket = () => socket

export const connectChatRealtime = (userId) => {
  const normalizedUserId = String(userId || '').trim()
  if (!normalizedUserId) return null

  if (!socket) {
    socket = io(SOCKET_CONNECTION_URL, {
      autoConnect: true,
      reconnection: true,
      transports: ['websocket', 'polling']
    })

    socket.on('connect', () => {
      if (registeredUserId) socket.emit('register', registeredUserId)
    })
  }

  registeredUserId = normalizedUserId
  if (!socket.connected) socket.connect()
  else socket.emit('register', registeredUserId)
  return socket
}

export const disconnectChatRealtime = () => {
  registeredUserId = ''
  if (!socket) return
  socket.removeAllListeners()
  socket.disconnect()
  socket = null
}

export const emitChatRealtime = (eventName, payload) => {
  if (!socket?.connected) return false
  socket.emit(eventName, payload)
  return true
}
